import { render, staticRenderFns } from "./AdminNuevoApunte.vue?vue&type=template&id=1c0a98e8&"
import script from "./AdminNuevoApunte.vue?vue&type=script&lang=js&"
export * from "./AdminNuevoApunte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports